import http from "@/settings/apiSettings"

class DrepturiRoluriDataService {

  save(data: any): Promise<any> {
    return http.clientAuth.post("/AUTH_DrepturiRoluri/AddDrepturiRoluri", data);
  }

  get(): Promise<any> {
    return http.clientAuth.get("/AUTH_DrepturiRoluri/GetDrepturiRoluri");
  }
  getAgenti(rolId: string): Promise<any> {
    return http.clientAuth.get(`/AUTH_DrepturiRoluri/GetAgenti/${rolId}`);
  }

  getUtilizatori(rolId: string): Promise<any> {
    return http.clientAuth.get(`/AUTH_RoluriUtilizatori/GetUtilizatori/${rolId}`);
  }

  getTipuri(rolId: string): Promise<any> {
    return http.clientAuth.get(`/AUTH_DrepturiRoluri/GetTipuriDocumente/${rolId}`);
  }

  getGestiuni(rolId: string): Promise<any> {
    return http.clientAuth.get(`/AUTH_DrepturiRoluri/GetGestiuni/${rolId}`);
  }

  getMeniuri(rolId: string): Promise<any> {
    return http.clientAuth.get(`/AUTH_DrepturiRoluri/GetMeniuri/${rolId}`);
  }

  getMeniuriCustom(rolId: string): Promise<any> {
    return http.clientAuth.get(`/AUTH_DrepturiRoluri/GetMeniuri/${rolId}`);
  }

  getCategoriiComenzi(rolId: string): Promise<any> {
    return http.clientAuth.get(`/AUTH_DrepturiRoluri/GetCategoriiComenzi/${rolId}`);
  }

  getCategoriiProduse(rolId: string): Promise<any> {
    return http.clientAuth.get(`/AUTH_DrepturiRoluri/GetPRO_Categorii/${rolId}`);
  }
  getCapitole(rolId: string): Promise<any> {
    return http.clientAuth.get(`/AUTH_DrepturiRoluri/GetDOC_Capitole/${rolId}`);
  }

  getCategoriiDocumente(rolId: string): Promise<any> {
    return http.clientAuth.get(`/AUTH_DrepturiRoluri/GetDOC_Categorii/${rolId}`);
  }

  updateRoluri(id: string, data: { Citeste?: boolean; Modifica?: boolean; Sterge?: boolean; }) {
    return http.clientAuth.patch(`/AUTH_DrepturiRoluri/UpdateDrepturiRoluri/${id}`, data);
  }
  getByRoleId(rolId: string) {
    return http.clientAuth.get(`/AUTH_DrepturiRoluri/GetByRolId/${encodeURIComponent(rolId)}`);
  }
  create(payload: { RolID: string; EntityID: number | string }) {
    return http.clientAuth.post('/AUTH_DrepturiRoluri/Create', payload);
  }
  // (opțional, dacă îl implementezi pe server)
  copyRights(payload: { sourceRoleId: string; targetRoleId: string }) {
    return http.clientAuth.post('/AUTH_DrepturiRoluri/CopyRights', payload);
  }



  delete(rolId: string, agentId: string, rightId?: string | null): Promise<any> {
    return http.clientAuth.delete(`/AUTH_DrepturiRoluri/DeleteDrepturiRoluri`, {
      data: {
        rolId,
        agentId,
        rightId,
        tip: 'AGENT'
      }

    });
  }


}

export default new DrepturiRoluriDataService();